/** Murf API helpers — voice catalog model + style lists. */

export const DEFAULT_MURF_VOICES_MODEL = 'GEN2';

export const MURF_SPEAKING_STYLES = [
  'Conversational',
  'Promo',
  'Newscast',
  'Storytelling',
  'Calm',
  'Furious',
  'Angry',
  'Sobbing',
  'Sad',
];

export function murfSpeakingStyleOptions(styles = MURF_SPEAKING_STYLES) {
  return (styles || []).map((s) => ({ value: String(s), label: String(s) }));
}

/** Fetch Murf voice catalog (GET /v1/speech/voices?model=GEN2). */
export function fetchMurfVoiceCatalog(api, { model = DEFAULT_MURF_VOICES_MODEL, locale } = {}) {
  const params = { model };
  if (locale) params.locale = locale;
  return api.get('/tts/voices/murf', { params });
}
